<template>
  <div class="content">
    <p class="strong">十九大第五次记者会，民政部人社部卫计委回答要点记录（摘录）</p>
     <div class="imgbox">
      <img src="../../assets/images/airsep/shijiuda.jpg" alt="">
    </div>
    <p>10月23日，十九大新闻中心举行了第五场记者招待会。教育部党组书记、部长陈宝生，民政部党组书记、部长黄树贤，人力资源社会保障部党组书记、部长尹蔚民，住房城乡建设部党组书记、部长王蒙徽，国家卫生计生委党组书记、主任李斌出席了本次记者招待会。</p>
    <p>医谷就相关要点辑录如下：</p>
    <p>民政部党组书记、部长黄树贤</p>
    <p>目前，全国注册登记的养老机构达到2.8万多家，养老床位近700万张，社区居家养老服务设施辐射所有的城镇社区和半数以上的农村社区。</p>
    <p>困难残疾人生活补贴和重度残疾人护理补贴制度全面建立，分别惠及1000多万残疾人。</p>
    <p>近50万孤儿和艾滋病病毒感染儿童纳入了政府保障。</p>
    <p>人力资源社会保障部党组书记、部长尹蔚民</p>
    <p>医疗保险，现在覆盖已经超过了13亿人，可以说已经实现了全民医保（国家卫计委主任李斌：基本医保的参保率一直在95%以上）。</p>
    <p>截至去年底，60岁以上的老年人口已经突破了2.3亿，占总人口的比重已经达到16.7%，其中65岁以上的老年人口已经突破了1.5亿，占总人口比重已经达到10.8%。今后一个时期，老年人的规模还将持续扩大，速度还在加快，而且持续的高峰时间比较长；</p>
    <p>目前，养老保险的覆盖率超过了90%，但是中国人口基数大，还有一个亿的人没有参加，主要是三种人：第一种是灵活就业人员。第二种是新业态就业人员。比如互联网业、快递业等。第三种，中小企业人员，特别是以农民工为主体的从业人员；</p>
    <p>养老保险基金的可持续发展问题。我国制度建设初期是上世纪九十年代，当时养老保险的抚养比是5：1，五个参保人养一个退休人员。随着老龄化的加剧，现在的抚养比已经降到了2.8：1，即2.8个人养1个人。而且再往前走，我刚才讲了老龄化的趋势还非常明显，抚养比还会持续下降，这样对养老保险的基金支付压力、可持续发展都带来了严峻的挑战；</p>
    <p>黑龙江是现在养老保险基金支付最困难的一个省份，它的抚养比是1.3：1；广东的抚养比最高，是9：1。实行全国统筹之后，就运用了社会保险的大数法则，互助共济。现在，养老保险基金每年大概当期结余都有4000多亿，累计结余是4万多亿，可以支撑16个月的发放，但是省与省之间不平衡。所以我们要尽快实现全国统筹，落实十九大报告的精神，先走第一步；</p>
    <p>养老保险基金的投资运营，国务院已经作出决定，现在已经有8个省份委托全国社会保障基金会在投资运营，有4000多个亿，也就使现在积累的养老基金能够保值增值；</p>
    <p>划拨国有资产充实社会保障基金，使社会保障基金这个蓄水池能够越来越大。这是近期我们在攻克第二个难题方面可能会采取的几项措施。长远的还有若干项措施，我们会成熟一项推出一项，这样能够使养老保险制度可持续发展，使所有的老年人生活都有保障。</p>
    <p>国家卫生计生委党组书记、主任李斌</p>
    <p>家庭医生签约服务已经覆盖了4.3亿人；</p>
    <p>县域内的就诊率已经达到了82.5%；</p>
    <p>民营医院的数量占比超过了57%；</p>
    <p>个人卫生支出占卫生总费用的比重从医改前2008年40.4%下降到30%以下，也是近二十年来的最低水平；</p>
    <p>继续加大民生的保障力度，扩大家庭医生的签约服务范围，有些困难家庭、慢性病家庭、老人家庭要重点覆盖。要继续实施改善医疗服务的行动计划，广泛推广预约诊疗、远程医疗、日间手术这样一些便民惠民措施。要进一步织牢织密基本医疗保障网，着力解决好农民工、“双创”人员异地就医的直接结算问题；</p>
    <p>要加大健康扶贫力度，扩大集中救治的病种；</p>
    <p>到2016年底，我国的医疗卫生机构发展到98万个，医疗卫生人员已经达到了1100多万人。十八大以来，每千人执业（助理）医师数从1.8人增长到2.3人，每千人注册护士数由1.5人增长到2.5人，每千人床位数由3.6张增加到5.4张；</p>
    <p>2016年，全国诊疗量达到了79亿人次，其中基层医疗机构的服务量超过了55%；</p>
    <p>全国90%的公立医院都参加了医联体改革，有6800多家公立医院开展了远程医疗服务；</p>
    <p>北京市今年四月初公立医院医药分开改革以来，扣除CPI的影响，医药费用增长不到2%，累计为患者节约了医药费用44亿元；</p>
    <p>制定了1200多个临床路径，基本覆盖了常见病种，已经在近七千家医院全面实施。规范了临床用药行为，医疗机构的抗菌药物用药率下降了近50%</p>
  </div>
</template>

<script>
export default {
  name: 'TabPressConference'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  .strong{
    color: #000000;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 18px;
    text-align: center;
  }
  p{
    line-height: 36px;
    text-indent:40px;
  }
  .imgbox{
    margin: 20px 0px;
    img{
      margin-top: 10px;
      border: 1px solid #fff;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
    }
  }
}
</style>
